module.exports = __webpack_public_path__ + "static/img/background.dcd2e473.svg";